<template>
    <UApp :toaster="{ position: 'top-center' }">
        <SessionExpirationModal />
        <AppLoadingIndicator />
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </UApp>
</template>

<script lang="ts" setup></script>
